export function Home() {
  return (
    <>
      <h3>Welcome to the CornellGO Manager!</h3>
      <br />
      <p>
        If you would like to create an organization under CornellGO, please
        contact <a href="mailto: hello@cornelldti.org">hello@cornelldti.org</a>.
      </p>
    </>
  );
}
